import {openClientSessionsSection} from '../ioPass/adapter';

/**
 * Canvas IO-Pass > Sessions.
 *
 * The guest access sessions IO-Pass has issued. Deliberately separate from
 * `client` and `historical_client`: those are wireless associations on the
 * network, and a guest session is a grant made by IO-Pass, with its own
 * plan and its own lifetime.
 */
const clientSessionsPlugin = {
	id: 'client_sessions',
	version: 1,
	commandVersion: 1,
	resource: 'client_sessions',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['iopass.dashboard'],
	},
	sections: {
		'iopass.client_sessions': openClientSessionsSection,
	},
};

export default clientSessionsPlugin;
